export default "__VITE_ASSET__abb0576d__"